// Generated types for AttributeExpansionTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { IntrinsicExpansionTaskReadAPI, IntrinsicExpansionTaskWriteAPI } from './intrinsicexpansiontask';
import { IntrinsicExpansionTaskReadAPISchemaObject, IntrinsicExpansionTaskWriteAPISchemaObject } from './intrinsicexpansiontask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface AttributeExpansionTaskReadAPI extends IntrinsicExpansionTaskReadAPI {
}

export interface AttributeExpansionTaskWriteAPI extends IntrinsicExpansionTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const AttributeExpansionTaskReadAPISchema: z.ZodType<AttributeExpansionTaskReadAPI> = IntrinsicExpansionTaskReadAPISchemaObject.extend({}).passthrough();

export const AttributeExpansionTaskWriteAPISchema: z.ZodType<AttributeExpansionTaskWriteAPI> = IntrinsicExpansionTaskWriteAPISchemaObject.extend({}).passthrough();
